<script setup>
definePage({
  meta: {
    layout: "default",
  },
});
// Router
const route = useRoute();
const router = useRouter();

const transactionShortcuts = [
  { title: "Dispute Handling", value: "admin-dispute-handling" },
  { title: "Fraud Transaction View", value: "admin-fraud-transaction" },
];
const reportShortcuts = [
  { title: "Clearing Report", value: "admin-clearing-report" },
  { title: "Settlement Report", value: "admin-settlement-report" },
  { title: "Center Balance", value: "admin-center-balance" },
  { title: "Transaction History", value: "admin-transaction-history" },
];
const masterDataShortcuts = [
  { title: "Mall", value: "admin-mall" },
  { title: "Merchant", value: "admin-merchant" },
  { title: "Shop", value: "admin-shop" },
  { title: "Location", value: "admin-location" },
  { title: "Card", value: "admin-card" },
  { title: "Card Holder", value: "admin-card-holders" },
  { title: "Terminal", value: "admin-terminal" },
];
</script>

<template>
  <VRow>
    <VCol cols="12" lg="4" sm="4">
      <div class="v-card-shortcut">
        <VCard>
          <VCardText class="d-flex flex-column pb-2">
            <VAvatar
              class="mb-4"
              color="primary"
              rounded
              size="50"
              variant="tonal"
            >
              <VIcon icon="tabler-report-money" size="2rem" />
            </VAvatar>

            <h4 class="text-h4">Transaction</h4>
          </VCardText>

          <VCardText>
            <VList :lines="three" nav>
              <VListItem
                v-for="item in transactionShortcuts"
                :key="item.value"
                :value="item.value"
              >
                <VListItemTitle>
                  <RouterLink
                    :to="{ name: item.value }"
                    class="text-primary ms-2 mb-1"
                  >
                    {{ item.title }}
                  </RouterLink>
                </VListItemTitle>
              </VListItem>
            </VList>
          </VCardText>
        </VCard>
      </div>
    </VCol>
    <VCol cols="12" lg="4" sm="4">
      <div class="v-card-shortcut">
        <VCard>
          <VCardText class="d-flex flex-column pb-2">
            <VAvatar
              class="mb-4"
              color="success"
              rounded
              size="50"
              variant="tonal"
            >
              <VIcon icon="tabler-report" size="2rem" />
            </VAvatar>

            <h4 class="text-h4">Report</h4>
          </VCardText>

          <VCardText>
            <VList :lines="false" nav>
              <VListItem
                v-for="item in reportShortcuts"
                :key="item.value"
                :value="item.value"
              >
                <VListItemTitle>
                  <RouterLink
                    :to="{ name: item.value }"
                    class="text-primary ms-2 mb-1"
                  >
                    {{ item.title }}
                  </RouterLink>
                </VListItemTitle>
              </VListItem>
            </VList>
          </VCardText>
        </VCard>
      </div>
    </VCol>
    <VCol cols="12" lg="4" sm="4">
      <div class="v-card-shortcut">
        <VCard>
          <VCardText class="d-flex flex-column pb-2">
            <VAvatar
              class="mb-4"
              color="warning"
              rounded
              size="50"
              variant="tonal"
            >
              <VIcon icon="tabler-database" size="2rem" />
            </VAvatar>

            <h4 class="text-h4">Master Data</h4>
          </VCardText>

          <VCardText>
            <VList :lines="false" nav>
              <VListItem
                v-for="item in masterDataShortcuts"
                :key="item.value"
                :value="item.value"
              >
                <VListItemTitle>
                  <RouterLink
                    :to="{ name: item.value }"
                    class="text-primary ms-2 mb-1"
                  >
                    {{ item.title }}
                  </RouterLink>
                </VListItemTitle>
              </VListItem>
            </VList>
          </VCardText>
        </VCard>
      </div>
    </VCol>
  </VRow>
</template>
